import React from 'react';

const HowToMeasure = ({ gender }: { gender: string }) => {
  return (
    <>
      <div className="how-to-measure" tabIndex={0}>
        <h6 className="h6 uppercase size-guide-section-title">How to measure</h6>
        <p className="small-p">
          {gender === 'men' ? 'Chest' : 'Bust'}:{' '}
          <span>Place the measuring tape around the fullest part of your chest directly under your arms.</span>
        </p>
        <p className="small-p">
          Waist: <span>Measure around your natural waistline at belly button level.</span>
        </p>
        <p className="small-p">
          Hips: <span>Measure around the fullest part of your body at the top of your leg</span>
        </p>
        <p className="small-p">
          Inseam: <span>With no shoes on, measure from the groin down to the floor.</span>
        </p>
        <p className="small-p unsure-on-sizes" tabIndex={0}>
          Unsure on Sizes? <br /> <span>Contact our style experts</span> <a href="/pages/contact-us">here</a>
        </p>
      </div>
    </>
  );
};

export default HowToMeasure;
